export default {
  name: 'supersetMixin',
  methods: {
    // this method is called from the configuration in the resultMapperMethod properties
    supersetMap (apiResul) {
      const resultData = apiResul.result[0].data
      const totalItems = resultData.length
      return {
        totalitems: totalItems,
        items: resultData
      }
    }
  }
}
